import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import { cardContentStyles } from "../../../theme/mixins";

export const EmployerStatsWrapper = styled.div`
  width: 500px;
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.white};
  margin: 0 15px;
  height: fit-content;
  display: inline-block;
  padding: 0 20px 20px 20px;

  ${mediaMaxWidth.smallDesktop} {
    margin-left: 7.5px;
  }

  ${mediaMaxWidth.tablet} {
    margin: 15px;
    order: -1;
  }

  ${mediaMaxWidth.phone} {
    width: unset;
    margin: 10px;
    padding: 0 10px 10px 10px;
  }

  ${mediaMaxWidth.smallPhone} {
    margin: 5px;
  }
`;

export const Content = styled.div`
  ${cardContentStyles};
  justify-content: space-between;
`;
